import * as React from "react";
import { addHours } from "date-fns";

import {
  IClass,
  IClassForRegister,
  ILoginMFAResponse,
  ILoginResponse,
  INotification,
  ISchoolDocumentListItem,
  TManagerSchoolDocumentCategory,
  IStudentPlan,
  IReportEntry,
  IStudent,
  IStudentForRegister,
  ISubClass,
  ISummaryPerClass,
  ISummaryPerTeacher,
  ITeacher,
  ITeacherForRegister,
  ITotalStatus,
  IUserManager,
  IFile,
  UploadStudentRealPhotosRequest,
  UploadStudentRealPhotosResponse,
  BulkUpsertStudentRealPhotosRequest,
  TeacherSubject,
  TeacherSubjectForBulkRegister,
  Subject,
  SubjectCategory,
} from "../state";

export const prefixPath = "/manager";
export const homePath = `/`;
export const loginPath = `/login`;
export const authenticationPath = `/authentication`;
export const teachersPath = "/teachers";
export const newTeacherPath = "/new_teacher";
export const editTeacherPath = "/edit_teacher";
export const bulkRegisterTeachersPath = "/bulk_register_teachers";
export const classesPath = "/classes";
export const nextYearClassesPath = "/next_year_classes";
export const subClassesPath = "/sub_classes";
export const newClassPath = "/new_class";
export const newNextYearClassPath = "/new_next_year_class";
export const editClassPath = "/edit_class";
export const editNextYearClassPath = "/edit_next_year_class";
export const newSubClassPath = "/new_sub_class";
export const editSubClassPath = "/edit_sub_class";
export const editSubClassStudentPath = "/edit_sub_class_student";
export const studentsPath = "/students";
export const nextYearStudentsPath = "/next_year_students";
export const bulkEditStudentsPath = "/bulk_edit_students";
export const bulkEditNextYearStudentsPath = "/bulk_edit_next_year_students";
export const bulkEditClassesPath = "/bulk_edit_classes";
export const bulkEditNextYearClassesPath = "/bulk_edit_next_year_classes";
export const newStudentPath = "/new_student";
export const bulkRegisterStudentsPath = "/bulk_register_students";
export const bulkRegisterNextYearStudentsPath =
  "/bulk_register_next_year_students";
export const newNextYearStudentPath = "/new_next_year_student";
export const editStudentPath = "/edit_student";
export const editNextYearStudentPath = "/edit_next_year_student";
export const notificationsPath = `/notifications`;
export const newNotificationPath = `/new_notification`;
export const editNotificationPath = `/edit_notification`;
export const copyNotificationPath = `/copy_notification`;
export const registrationNumChangeRequestPath = `/registration_num_change_request`;
export const contractManagementPath = `/contract_management`;
export const schoolDocumentsPath = `/school_documents`;
export const gearStatusPath = `/gear_status`;
export const exchangeSchoolYearPath = "/exchange_school_year";
export const useHistoriesPath = "/use_histories";
export const uploadStudentRealPhotosPath = "/upload_student_real_photos";
export const subjectsPath = "/subjects";
export const subjectRegistrationPath = "/subject_registration";
export const bulkRegisterTeacherSubjectsPath =
  "/bulk_register_teacher_subjects";
export const CLEAR_SUCCESS_MESSAGE = "CLEAR_SUCCESS_MESSAGE";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";
export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const VERIFY_MFA = "VERIFY_MFA";
export const VERIFY_MFA_SUCCESS = "VERIFY_MFA_SUCCESS";
export const VERIFY_MFA_FAILURE = "VERIFY_MFA_FAILURE";
export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";
export const FETCH_INITIAL_DATA = "FETCH_INITIAL_DATA";
export const FETCH_INITIAL_DATA_SUCCESS = "FETCH_INITIAL_DATA_SUCCESS";
export const FETCH_INITIAL_DATA_FAILURE = "FETCH_INITIAL_DATA_FAILURE";
export const FETCH_TEACHERS = "FETCH_TEACHERS";
export const FETCH_TEACHERS_SUCCESS = "FETCH_TEACHERS_SUCCESS";
export const FETCH_TEACHERS_FAILURE = "FETCH_TEACHERS_FAILURE";
export const FETCH_TEACHER = "FETCH_TEACHER";
export const FETCH_TEACHER_SUCCESS = "FETCH_TEACHER_SUCCESS";
export const FETCH_TEACHER_FAILURE = "FETCH_TEACHER_FAILURE";
export const CREATE_TEACHER = "CREATE_TEACHER";
export const CREATE_TEACHER_SUCCESS = "CREATE_TEACHER_SUCCESS";
export const CREATE_TEACHER_FAILURE = "CREATE_TEACHER_FAILURE";
export const UPDATE_TEACHER = "UPDATE_TEACHER";
export const UPDATE_TEACHER_SUCCESS = "UPDATE_TEACHER_SUCCESS";
export const UPDATE_TEACHER_FAILURE = "UPDATE_TEACHER_FAILURE";
export const BULK_REGISTER_TEACHERS = "BULK_REGISTER_TEACHERS";
export const DELETE_TEACHER = "DELETE_TEACHER";
export const DELETE_TEACHER_SUCCESS = "DELETE_TEACHER_SUCCESS";
export const DELETE_TEACHER_FAILURE = "DELETE_TEACHER_FAILURE";
export const FETCH_CLASSES = "FETCH_CLASSES";
export const FETCH_CLASSES_SUCCESS = "FETCH_CLASSES_SUCCESS";
export const FETCH_CLASSES_FAILURE = "FETCH_CLASSES_FAILURE";
export const FETCH_NEXT_CLASSES = "FETCH_NEXT_CLASSES";
export const FETCH_NEXT_CLASSES_SUCCESS = "FETCH_NEXT_CLASSES_SUCCESS";
export const FETCH_SUB_CLASSES = "FETCH_SUB_CLASSES";
export const FETCH_SUB_CLASSES_SUCCESS = "FETCH_SUB_CLASSES_SUCCESS";
export const FETCH_SUB_CLASSES_FAILURE = "FETCH_SUB_CLASSES_FAILURE";
export const DELETE_SUB_CLASS_SUCCESS = "DELETE_SUB_CLASS_SUCCESS";
export const FETCH_CLASS = "FETCH_CLASS";
export const FETCH_CLASS_SUCCESS = "FETCH_CLASS_SUCCESS";
export const FETCH_CLASS_FAILURE = "FETCH_CLASS_FAILURE";
export const CREATE_CLASS = "CREATE_CLASS";
export const CREATE_CLASS_SUCCESS = "CREATE_CLASS_SUCCESS";
export const CREATE_CLASS_FAILURE = "CREATE_CLASS_FAILURE";
export const UPDATE_CLASS = "UPDATE_CLASS";
export const UPDATE_CLASS_SUCCESS = "UPDATE_CLASS_SUCCESS";
export const UPDATE_CLASS_FAILURE = "UPDATE_CLASS_FAILURE";
export const DELETE_CLASS = "DELETE_CLASS";
export const DELETE_CLASS_SUCCESS = "DELETE_CLASS_SUCCESS";
export const DELETE_CLASS_FAILURE = "DELETE_CLASS_FAILURE";
export const UPDATE_SUB_CLASS_STUDENTS = "UPDATE_SUB_CLASS_STUDENTS";
export const UPDATE_SUB_CLASS_STUDENTS_SUCCESS =
  "UPDATE_SUB_CLASS_STUDENTS_SUCCESS";
export const UPDATE_SUB_CLASS_STUDENTS_FAILURE =
  "UPDATE_SUB_CLASS_STUDENTS_FAILURE";
export const DELETE_SUB_CLASS = "DELETE_SUB_CLASS";
export const FETCH_STUDENTS = "FETCH_STUDENTS";
export const FETCH_STUDENTS_SUCCESS = "FETCH_STUDENTS_SUCCESS";
export const FETCH_STUDENTS_FAILURE = "FETCH_STUDENTS_FAILURE";
export const FETCH_NEXT_YEAR_STUDENTS = "FETCH_NEXT_YEAR_STUDENTS";
export const FETCH_NEXT_YEAR_STUDENTS_SUCCESS =
  "FETCH_NEXT_YEAR_STUDENTS_SUCCESS";
export const FETCH_NEXT_YEAR_STUDENTS_FAILURE =
  "FETCH_NEXT_YEAR_STUDENTS_FAILURE";
export const CLEAR_STUDENTS = "CLEAR_STUDENTS";
export const FETCH_STUDENT = "FETCH_STUDENT";
export const FETCH_STUDENT_SUCCESS = "FETCH_STUDENT_SUCCESS";
export const FETCH_STUDENT_FAILURE = "FETCH_STUDENT_FAILURE";
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";
export const FETCH_NOTIFICATION = "FETCH_NOTIFICATION";
export const FETCH_NOTIFICATION_SUCCESS = "FETCH_NOTIFICATION_SUCCESS";
export const FETCH_NOTIFICATION_FAILURE = "FETCH_NOTIFICATION_FAILURE";
export const FETCH_REPORTS = "FETCH_REPORTS";
export const FETCH_REPORTS_SUCCESS = "FETCH_REPORTS_SUCCESS";
export const FETCH_REPORTS_FAILURE = "FETCH_REPORTS_FAILURE";
export const CREATE_STUDENT = "CREATE_STUDENT";
export const CREATE_STUDENT_SUCCESS = "CREATE_STUDENT_SUCCESS";
export const CREATE_STUDENT_FAILURE = "CREATE_STUDENT_FAILURE";
export const RESET_STUDENT_PASSWORD = "RESET_STUDENT_PASSWORD";
export const RESET_STUDENT_PASSWORD_SUCCESS = "RESET_STUDENT_PASSWORD_SUCCESS";
export const RESET_STUDENT_PASSWORD_FAILURE = "RESET_STUDENT_PASSWORD_FAILURE";
export const BULK_UPSERT_STUDENTS = "BULK_UPSERT_STUDENTS";
export const BULK_UPSERT_STUDENTS_SUCCESS = "BULK_UPSERT_STUDENTS_SUCCESS";
export const BULK_UPSERT_STUDENTS_FAILURE = "BULK_UPSERT_STUDENTS_FAILURE";
export const BULK_UPSERT_TEACHER_SUBJECTS = "BULK_UPSERT_TEACHER_SUBJECTS";
export const BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS =
  "BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS";
export const BULK_UPSERT_TEACHER_SUBJECTS_FAILURE =
  "BULK_UPSERT_TEACHER_SUBJECTS_FAILURE";
export const BULK_UPSERT_CLASSES = "BULK_UPSERT_CLASSES";
export const BULK_UPSERT_CLASSES_SUCCESS = "BULK_UPSERT_CLASSES_SUCCESS";
export const BULK_UPSERT_CLASSES_FAILURE = "BULK_UPSERT_CLASSES_FAILURE";
export const BULK_REGISTER_TEACHERS_SUCCESS = "BULK_REGISTER_TEACHERS_SUCCESS";
export const BULK_REGISTER_TEACHERS_FAILURE = "BULK_REGISTER_TEACHERS_FAILURE";
export const FETCH_STUDENT_PLANS = "FETCH_STUDENT_PLANS";
export const FETCH_STUDENT_PLANS_SUCCESS = "FETCH_STUDENT_PLANS_SUCCESS";
export const FETCH_STUDENT_PLANS_FAILURE = "FETCH_STUDENT_PLANS_FAILURE";
export const DISABLE_STUDENT_PLANS = "DISABLE_STUDENT_PLANS";
export const DISABLE_STUDENT_PLANS_SUCCESS = "DISABLE_STUDENT_PLANS_SUCCESS";
export const DISABLE_STUDENT_PLANS_FAILURE = "DISABLE_STUDENT_PLANS_FAILURE";
export const UPDATE_STUDENT = "UPDATE_STUDENT";
export const UPDATE_STUDENT_SUCCESS = "UPDATE_STUDENT_SUCCESS";
export const UPDATE_STUDENT_FAILURE = "UPDATE_STUDENT_FAILURE";
export const DELETE_STUDENT = "DELETE_STUDENT";
export const DELETE_STUDENT_SUCCESS = "DELETE_STUDENT_SUCCESS";
export const DELETE_STUDENT_FAILURE = "DELETE_STUDENT_FAILURE";
export const BULK_DELETE_STUDENTS = "BULK_DELETE_STUDENTS";
export const BULK_DELETE_STUDENTS_SUCCESS = "BULK_DELETE_STUDENTS_SUCCESS";
export const BULK_DELETE_STUDENTS_FAILURE = "BULK_DELETE_STUDENTS_FAILURE";
export const FETCH_TEMPORARY_TOKEN = "FETCH_TEMPORARY_TOKEN";
export const FETCH_TEMPORARY_TOKEN_SUCCESS = "FETCH_TEMPORARY_TOKEN_SUCCESS";
export const FETCH_TEMPORARY_TOKEN_FAILURE = "FETCH_TEMPORARY_TOKEN_FAILURE";
export const CLEAR_TEMPORARY_TOKEN = "CLEAR_TEMPORARY_TOKEN";
export const CLEAR_OTT = "CLEAR_OTT";
export const FETCH_TOTAL_STATUS = "FETCH_TOTAL_STATUS";
export const FETCH_TOTAL_STATUS_SUCCESS = "FETCH_TOTAL_STATUS_SUCCESS";
export const FETCH_TOTAL_STATUS_FAILURE = "FETCH_TOTAL_STATUS_FAILURE";
export const FETCH_SUMMARY_PER_CLASS = "FETCH_SUMMARY_PER_CLASS";
export const FETCH_SUMMARY_PER_CLASS_SUCCESS =
  "FETCH_SUMMARY_PER_CLASS_SUCCESS";
export const FETCH_SUMMARY_PER_CLASS_FAILURE =
  "FETCH_SUMMARY_PER_CLASS_FAILURE";
export const FETCH_SUMMARY_PER_TEACHER = "FETCH_SUMMARY_PER_TEACHER";
export const FETCH_SUMMARY_PER_TEACHER_SUCCESS =
  "FETCH_SUMMARY_PER_TEACHER_SUCCESS";
export const FETCH_SUMMARY_PER_TEACHER_FAILURE =
  "FETCH_SUMMARY_PER_TEACHER_FAILURE";
export const FETCH_PLANS = "FETCH_PLANS";
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS";
export const FETCH_PLANS_FAILURE = "FETCH_PLANS_FAILURE";
export const CREATE_NOTIFICATION = "CREATE_NOTIFICATION";
export const CREATE_NOTIFICATION_SUCCESS = "CREATE_NOTIFICATION_SUCCESS";
export const CREATE_NOTIFICATION_FAILURE = "CREATE_NOTIFICATION_FAILURE";
export const UPDATE_NOTIFICATION = "UPDATE_NOTIFICATION";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAILURE = "UPDATE_NOTIFICATION_FAILURE";
export const DESTROY_NOTIFICATION = "DESTROY_NOTIFICATION";
export const DESTROY_NOTIFICATION_SUCCESS = "DESTROY_NOTIFICATION_SUCCESS";
export const DESTROY_NOTIFICATION_FAILURE = "DESTROY_NOTIFICATION_FAILURE";
export const CREATE_SCHOOL_ORDER_CHANGE_REQUEST =
  "CREATE_SCHOOL_ORDER_CHANGE_REQUEST";
export const CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS =
  "CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS";
export const CREATE_SCHOOL_ORDER_CHANGE_REQUEST_FAILURE =
  "CREATE_SCHOOL_ORDER_CHANGE_REQUEST_FAILURE";
export const FETCH_SCHOOL_DOCUMENTS = "FETCH_SCHOOL_DOCUMENTS";
export const FETCH_SCHOOL_DOCUMENTS_SUCCESS = "FETCH_SCHOOL_DOCUMENTS_SUCCESS";
export const FETCH_SCHOOL_DOCUMENTS_FAILURE = "FETCH_SCHOOL_DOCUMENTS_FAILURE";
export const MASQUERADE_TEACHER = "MASQUERADE_TEACHER";
export const MASQUERADE_TEACHER_SUCCESS = "MASQUERADE_TEACHER_SUCCESS";
export const MASQUERADE_TEACHER_FAILURE = "MASQUERADE_TEACHER_FAILURE";
export const MASQUERADE_STUDENT = "MASQUERADE_STUDENT";
export const MASQUERADE_STUDENT_SUCCESS = "MASQUERADE_STUDENT_SUCCESS";
export const MASQUERADE_STUDENT_FAILURE = "MASQUERADE_STUDENT_FAILURE";
export const EXCHANGE_YEAR_NOW_REQUEST = "EXCHANGE_YEAR_NOW_REQUEST";
export const EXCHANGE_YEAR_NOW_REQUEST_SUCCESS =
  "EXCHANGE_YEAR_NOW_REQUEST_SUCCESS";
export const EXCHANGE_YEAR_NOW_REQUEST_FAILURE =
  "EXCHANGE_YEAR_NOW_REQUEST_FAILURE";
export const CHECK_SCHOOL_STATUS = "CHECK_SCHOOL_STATUS";
export const CHECK_SCHOOL_STATUS_SUCCESS = "CHECK_SCHOOL_STATUS_SUCCESS";
export const FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES =
  "FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES";
export const FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES_SUCCESS =
  "FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES_SUCCESS";
export const UPLOAD_STUDENT_REAL_PHOTOS = "UPLOAD_STUDENT_REAL_PHOTOS";
export const UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS =
  "UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS";
export const UPLOAD_STUDENT_REAL_PHOTOS_FAILURE =
  "UPLOAD_STUDENT_REAL_PHOTOS_FAILURE";
export const DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE =
  "DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE";
export const DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_SUCCESS =
  "DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_SUCCESS";
export const DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE =
  "DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE";
export const CLEAR_STUDENT_REAL_PHOTOS = "CLEAR_STUDENT_REAL_PHOTOS";
export const BULK_UPSERT_STUDENT_REAL_PHOTOS =
  "BULK_UPSERT_STUDENT_REAL_PHOTOS";
export const BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS =
  "BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS";
export const BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE =
  "BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE";
export const FETCH_TEACHER_SUBJECTS_BY_SCHOOL =
  "FETCH_TEACHER_SUBJECTS_BY_SCHOOL";
export const FETCH_TEACHER_SUBJECTS_BY_SCHOOL_SUCCESS =
  "FETCH_TEACHER_SUBJECTS_BY_SCHOOL_SUCCESS";
export const FETCH_TEACHER_SUBJECTS_BY_TEACHER =
  "FETCH_TEACHER_SUBJECTS_BY_TEACHER";
export const FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS =
  "FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS";
export const FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS_MESSAGE =
  "教科の取得に成功しました";
export const SUBMIT_TEACHER_SUBJECTS = "SUBMIT_TEACHER_SUBJECTS";
export const SUBMIT_TEACHER_SUBJECTS_SUCCESS =
  "SUBMIT_TEACHER_SUBJECTS_SUCCESS";
export const SUBMIT_TEACHER_SUBJECTS_SUCCESS_MESSAGE =
  "教科の登録に成功しました";
export const SUBMIT_TEACHER_SUBJECTS_FAILURE =
  "SUBMIT_TEACHER_SUBJECTS_FAILURE";
export const SUBMIT_TEACHER_SUBJECTS_FAILURE_MESSAGE =
  "教科の登録に失敗しました";
export const DELETE_TEACHER_SUBJECT = "DELETE_TEACHER_SUBJECT";
export const DELETE_TEACHER_SUBJECT_SUCCESS = "DELETE_TEACHER_SUBJECT_SUCCESS";
export const DELETE_TEACHER_SUBJECT_SUCCESS_MESSAGE =
  "教科の削除に成功しました";
export const DELETE_TEACHER_SUBJECT_FAILURE = "DELETE_TEACHER_SUBJECT_FAILURE";
export const DELETE_TEACHER_SUBJECT_FAILURE_MESSAGE =
  "教科の削除に失敗しました";
export const FETCH_SUBJECTS = "FETCH_SUBJECTS";
export const FETCH_SUBJECTS_SUCCESS = "FETCH_SUBJECTS_SUCCESS";
export const FETCH_SUBJECT_CATEGORIES = "FETCH_SUBJECT_CATEGORIES";
export const FETCH_SUBJECT_CATEGORIES_SUCCESS =
  "FETCH_SUBJECT_CATEGORIES_SUCCESS";
export const SUBMIT_SUBJECT = "SUBMIT_SUBJECT";
export const SUBMIT_SUBJECT_SUCCESS = "SUBMIT_SUBJECT_SUCCESS";
export const SUBMIT_SUBJECT_SUCCESS_MESSAGE = "教科の登録に成功しました";
export const SUBMIT_SUBJECT_FAILURE = "SUBMIT_SUBJECT_FAILURE";
export const SUBMIT_SUBJECT_FAILURE_MESSAGE = "教科の登録に失敗しました";
export const UPDATE_SUBJECT = "UPDATE_SUBJECT";
export const UPDATE_SUBJECT_SUCCESS = "UPDATE_SUBJECT_SUCCESS";
export const UPDATE_SUBJECT_SUCCESS_MESSAGE = "教科の更新に成功しました";
export const UPDATE_SUBJECT_FAILURE = "UPDATE_SUBJECT_FAILURE";
export const UPDATE_SUBJECT_FAILURE_MESSAGE = "教科の更新に失敗しました";
export const DELETE_SUBJECT = "DELETE_SUBJECT";
export const DELETE_SUBJECT_SUCCESS = "DELETE_SUBJECT_SUCCESS";
export const DELETE_SUBJECT_SUCCESS_MESSAGE = "教科の削除に成功しました";
export const DELETE_SUBJECT_FAILURE = "DELETE_SUBJECT_FAILURE";
export const DELETE_SUBJECT_FAILURE_MESSAGE = "教科の削除に失敗しました";

export const FETCH_STUDENTS_SUCCESS_MESSAGE = "生徒の取得に成功しました";
export const FETCH_NEXT_YEAR_STUDENTS_SUCCESS_MESSAGE =
  "来年度生徒の取得に成功しました";
export const RESET_STUDENTS_SUCCESS_MESSAGE = "データをリセットしました";
export const CREATE_TEACHER_SUCCESS_MESSAGE = "先生の登録に成功しました";
export const UPDATE_TEACHER_SUCCESS_MESSAGE = "先生の更新に成功しました";
export const DELETE_TEACHER_SUCCESS_MESSAGE = "先生の削除に成功しました";
export const CREATE_STUDENT_SUCCESS_MESSAGE = "生徒の登録に成功しました";
export const UPDATE_STUDENT_SUCCESS_MESSAGE = "生徒の更新に成功しました";
export const DELETE_STUDENT_SUCCESS_MESSAGE = "生徒の削除に成功しました";
export const BULK_DELETE_STUDENTS_SUCCESS_MESSAGE =
  "生徒の一括削除に成功しました";
export const BULK_DELETE_STUDENTS_FAILURE_MESSAGE =
  "生徒の一括削除に失敗しました";
export const CREATE_CLASS_SUCCESS_MESSAGE = "クラスの登録に成功しました";
export const UPDATE_CLASS_SUCCESS_MESSAGE = "クラスの更新に成功しました";
export const DELETE_CLASS_SUCCESS_MESSAGE = "クラスの削除に成功しました";
export const BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE =
  "生徒の一括更新に成功しました";
export const BULK_UPSERT_CLASSES_SUCCESS_MESSAGE =
  "クラスの一括更新に成功しました";
export const BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE =
  "先生の一括登録・更新に成功しました";
export const BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS_MESSAGE =
  "教科担当の一括編集に成功しました";
export const DISABLE_STUDENT_PLANS_SUCCESS_MESSAGE =
  "プランが無効になりました。";
export const FETCH_STUDENT_PLANS_SUCCESS_MESSAGE = "プランの取得に成功しました";
export const FETCH_CLASSES_SUCCESS_MESSAGE = "クラスの取得に成功しました";
export const FETCH_NEXT_CLASSES_SUCCESS_MESSAGE =
  "次のクラスの取得に成功しました";
export const FETCH_SUB_CLASSES_SUCCESS_MESSAGE =
  "サブクラスの取得に成功しました";
export const DELETE_SUB_CLASS_SUCCESS_MESSAGE = "グループの削除に成功しました";
export const UPDATE_SUB_CLASS_STUDENT_SUCCESS_MESSAGE =
  "クラスの更新に成功しました";
export const FETCH_NOTIFICATIONS_SUCCESS_MESSAGE =
  "お知らせの取得に成功しました";
export const CREATE_NOTIFICATION_SUCCESS_MESSAGE =
  "お知らせの作成に成功しました";
export const UPDATE_NOTIFICATION_SUCCESS_MESSAGE =
  "お知らせの更新に成功しました";
export const DESTROY_NOTIFICATION_SUCCESS_MESSAGE =
  "お知らせの削除に成功しました";
export const CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS_MESSAGE =
  "利用可能人数変更申請を送信しました";
export const MASQUERADE_STUDENT_SUCCESS_MESSAGE =
  "生徒の代理ログイン用トークンの取得が完了しました";
export const MASQUERADE_TEACHER_SUCCESS_MESSAGE =
  "先生の代理ログイン用トークンの取得が完了しました";
export const EXCHANGE_YEAR_NOW_REQUEST_SUCCESS_MESSAGE =
  "年度更新中、しばらくお待ちください";
export const EXCHANGE_YEAR_NOW_UPDATED_SUCCESS_MESSAGE =
  "年度更新に成功しました";
export const FETCH_PLANS_SUCCESS_MESSAGE = "プランの取得に成功しました";
export const FETCH_PLANS_FAILURE_MESSAGE = "プランの取得に失敗しました";
export const UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS_MESSAGE =
  "生徒の顔写真アップロードに成功しました";
export const UPLOAD_STUDENT_REAL_PHOTOS_FAILURE_MESSAGE =
  "生徒の顔写真アップロードに失敗しました";
export const DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE_MESSAGE =
  "画像一覧の画像削除に失敗しました";
export const BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS_MESSAGE =
  "生徒と顔写真の一括登録に成功しました";
export const BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE_MESSAGE =
  "生徒と顔写真の一括登録に失敗しました";
export const DELETE_REALIZATION_SUCCESS_MESSAGE =
  "報告されたストックの削除に成功しました";

export const UPDATE_SCHOOL_STOCK_C_TO_C = "UPDATE_SCHOOL_STOCK_C_TO_C";
export const UPDATE_SCHOOL_STOCK_C_TO_C_SUCCESS =
  "UPDATE_SCHOOL_STOCK_C_TO_C_SUCCESS";
export const UPDATE_SCHOOL_STOCK_C_TO_C_FAILURE =
  "UPDATE_SCHOOL_STOCK_C_TO_C_FAILURE";

export const DELETE_REALIZATION = "DELETE_REALIZATION";
export const DELETE_REALIZATION_SUCCESS = "DELETE_REALIZATION_SUCCESS";
export const DELETE_REALIZATION_FAILURE = "DELETE_REALIZATION_FAILURE";

export const LOGOUT_SUCCESS_MESSAGE = "ログアウトしました。";

export const ACTION_503 = "ACTION_503";
export const ACTION_503_MESSAGE = "サービスが利用できません";

export const API_URL = `${
  process.env.REACT_APP_API_URL ??
  window.location.protocol + "//" + window.location.host
}/api/v1/manager`;

export const login = (email: string, password: string) => ({
  types: LOGIN as typeof LOGIN,
  payload: {
    request: {
      data: { email, password },
      method: "post",
      url: `${API_URL}/login`,
    },
  },
});

export const verifyMFA = (ott: string, mfa_code: string) => ({
  types: VERIFY_MFA as typeof VERIFY_MFA,
  payload: {
    request: {
      data: { ott, mfa_code },
      method: "post",
      url: `${API_URL}/user_managers/verify_mfa`,
    },
  },
});

export const logout = () => ({
  types: LOGOUT as typeof LOGOUT,
  payload: {
    request: {
      data: {},
      method: "delete",
      url: `${API_URL}/logout`,
    },
  },
});

export const fetchInitialData = () => ({
  types: FETCH_INITIAL_DATA as typeof FETCH_INITIAL_DATA,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/user_managers/initial_data`,
    },
  },
});

export const bulkUpsertStudents = (students: IStudentForRegister[]) => ({
  types: BULK_UPSERT_STUDENTS as typeof BULK_UPSERT_STUDENTS,
  payload: {
    request: {
      data: { students },
      method: "POST",
      url: `${API_URL}/students/bulk_upsert`,
    },
  },
});

export const bulkRegisterTeachers = (teachers: ITeacherForRegister[]) => ({
  types: BULK_REGISTER_TEACHERS as typeof BULK_REGISTER_TEACHERS,
  payload: {
    request: {
      data: { teachers },
      method: "POST",
      url: `${API_URL}/teachers/bulk_upsert`,
    },
  },
});

export const bulkUpsertClasses = (
  year: number,
  classes: IClassForRegister[],
) => ({
  types: BULK_UPSERT_CLASSES as typeof BULK_UPSERT_CLASSES,
  payload: {
    request: {
      data: { year, classes },
      method: "POST",
      url: `${API_URL}/classes/bulk_upsert`,
    },
  },
});

export const bulkUpsertTeacherSubjects = (
  teacher_subjects: TeacherSubjectForBulkRegister[],
) => ({
  types: BULK_UPSERT_TEACHER_SUBJECTS as typeof BULK_UPSERT_TEACHER_SUBJECTS,
  payload: {
    request: {
      data: { teacher_subjects },
      method: "POST",
      url: `${API_URL}/teacher_subjects/bulk_upsert`,
    },
  },
});

export const disableStudentPlans = (id: number, end_at: string) => ({
  types: DISABLE_STUDENT_PLANS as typeof DISABLE_STUDENT_PLANS,
  payload: {
    request: {
      data: { end_at },
      method: "POST",
      url: `${API_URL}/students/${id}/disable_plan`,
    },
  },
});

export const fetchStudentPlans = () => ({
  types: FETCH_STUDENT_PLANS as typeof FETCH_STUDENT_PLANS,
  payload: {
    request: {
      data: {},
      method: "GET",
      url: `${API_URL}/student_plans`,
    },
  },
});

export const fetchTeachers = () => ({
  types: FETCH_TEACHERS as typeof FETCH_TEACHERS,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/teachers`,
    },
  },
});

export const fetchTeacher = (id: number) => ({
  types: FETCH_TEACHER as typeof FETCH_TEACHER,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/teachers/${id}`,
    },
  },
});

export const fetchReports = (target: string) => ({
  types: FETCH_REPORTS as typeof FETCH_REPORTS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/reports?target=${target}`,
    },
  },
});

export type ITeacherParam = {
  id: number;
  first_name: string;
  last_name: string;
  first_name_kana: string;
  last_name_kana: string;
  email: string;
  use_as_g4s_student?: boolean;
  g4s_class_id?: number;
  entrance_year?: number;
  current_grade?: number;
  next_grade?: number;
  is_user_manager?: boolean;
  receive_email_enabled?: boolean;
  photo?: IFile;
};

export const createTeacher = (teacher: ITeacherParam) => {
  let data;
  if (teacher.photo && teacher.photo.blob) {
    data = { ...teacher, photo: teacher.photo.blob };
  } else {
    data = { ...teacher };
  }
  return {
    types: CREATE_TEACHER as typeof CREATE_TEACHER,
    payload: {
      request: {
        data,
        method: "post",
        url: `${API_URL}/teachers`,
      },
    },
  };
};

export const updateTeacher = (teacher: ITeacherParam) => {
  let data;
  if (teacher.photo && teacher.photo.deleted && teacher.photo.id) {
    data = { ...teacher, photo: null, delete_photo: teacher.photo.id };
  } else if (teacher.photo && teacher.photo.blob) {
    data = { ...teacher, photo: teacher.photo.blob };
  } else {
    data = { ...teacher, photo: null };
  }

  return {
    types: UPDATE_TEACHER as typeof UPDATE_TEACHER,
    payload: {
      request: {
        data,
        method: "put",
        url: `${API_URL}/teachers/${teacher.id}`,
      },
    },
  };
};

export const deleteTeacher = (id: number) => ({
  types: DELETE_TEACHER as typeof DELETE_TEACHER,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/teachers/${id}`,
    },
  },
});

export type IClassParam = {
  id: number;
  year: number;
  grade: number;
  name: string;
  is_display_full_name?: boolean;
  teacher_ids: number[];
  is_sub: boolean;
};

export const createClass = (cls: IClassParam) => ({
  types: CREATE_CLASS as typeof CREATE_CLASS,
  payload: {
    request: {
      data: cls,
      method: "POST",
      url: `${API_URL}/classes`,
    },
  },
});

export const updateClass = (cls: IClassParam) => ({
  types: UPDATE_CLASS as typeof UPDATE_CLASS,
  payload: {
    request: {
      data: cls,
      method: "put",
      url: `${API_URL}/classes/${cls.id}`,
    },
  },
});

export const deleteClass = (id: number) => ({
  types: DELETE_CLASS as typeof DELETE_CLASS,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/classes/${id}`,
    },
  },
});

export const fetchClasses = (year: number, contains_dummy = false) => ({
  types: FETCH_CLASSES as typeof FETCH_CLASSES,
  payload: {
    request: {
      data: { year, contains_dummy },
      method: "get",
      url: `${API_URL}/classes`,
    },
  },
});

export const fetchNextClasses = (nextYear: number) => ({
  types: FETCH_NEXT_CLASSES as typeof FETCH_NEXT_CLASSES,
  payload: {
    request: {
      data: { year: nextYear },
      method: "get",
      url: `${API_URL}/classes`,
    },
  },
});

export const fetchSubClasses = () => ({
  types: FETCH_SUB_CLASSES as typeof FETCH_SUB_CLASSES,
  payload: {
    request: {
      data: {},
      method: "get",
      url: `${API_URL}/classes?is_sub=true`,
    },
  },
});

export const fetchClass = (id: number) => ({
  types: FETCH_CLASS as typeof FETCH_CLASS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/classes/${id}`,
    },
  },
});

export const updateSubClassStudents = (id: number, student_ids: number[]) => ({
  types: UPDATE_SUB_CLASS_STUDENTS as typeof UPDATE_SUB_CLASS_STUDENTS,
  payload: {
    request: {
      method: "POST",
      data: { student_ids },
      url: `${API_URL}/students_sub_classes/${id}/bulk_upsert`,
    },
  },
});

export const deleteSubClass = (id: number) => ({
  types: DELETE_SUB_CLASS as typeof DELETE_SUB_CLASS,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/sub_classes/${id}`,
    },
  },
});

export type IStudentParam = {
  id: number;
  klass_id: number | null;
  next_klass_id: number | null;
  first_name: string;
  last_name: string;
  first_name_kana: string;
  last_name_kana: string;
  student_no_in_school: string;
  entrance_year: number;
  current_grade: number | null;
  g4s_enabled: boolean;
  dlp_enabled: boolean;
  next_grade: number;
  email: string | null;
  guardian_email: string | null;
  plan_ids: number[];
};

export const createStudent = (student: IStudentParam) => ({
  types: CREATE_STUDENT as typeof CREATE_STUDENT,
  payload: {
    request: {
      data: student,
      method: "POST",
      url: `${API_URL}/students`,
    },
  },
});

export const updateStudent = (student: IStudentParam) => ({
  types: UPDATE_STUDENT as typeof UPDATE_STUDENT,
  payload: {
    request: {
      data: student,
      method: "PUT",
      url: `${API_URL}/students/${student.id}`,
    },
  },
});

export const deleteStudent = (id: number) => ({
  types: DELETE_STUDENT as typeof DELETE_STUDENT,
  payload: {
    request: {
      method: "DELETE",
      url: `${API_URL}/students/${id}`,
    },
  },
});

export type IFetchStudentsParam = {
  class_id?: string;
  entrance_year?: string;
  for_gear?: boolean;
  include_teacher?: boolean;
  include_real_photo?: boolean;
  include_can_destroy?: boolean;
};

export const fetchStudents = ({
  class_id,
  entrance_year,
  for_gear,
  include_teacher,
  include_real_photo,
  include_can_destroy,
}: IFetchStudentsParam = {}) => ({
  types: FETCH_STUDENTS as typeof FETCH_STUDENTS,
  payload: {
    request: {
      data: {
        class_id: class_id ?? "",
        entrance_year: entrance_year ?? "",
        for_gear: for_gear ?? false,
        include_teacher: include_teacher ?? false,
        include_real_photo: include_real_photo ?? false,
        include_can_destroy: include_can_destroy ?? false,
      },
      method: "get",
      url: `${API_URL}/students`,
    },
  },
});

export const bulkDeleteStudents = (student_ids: number[]) => ({
  types: BULK_DELETE_STUDENTS as typeof BULK_DELETE_STUDENTS,
  payload: {
    request: {
      data: { student_ids },
      method: "POST",
      url: `${API_URL}/students/bulk_destroy`,
    },
  },
});

export const fetchNextYearStudents = (
  class_id?: string,
  entrance_year?: string,
) => ({
  types: FETCH_NEXT_YEAR_STUDENTS as typeof FETCH_NEXT_YEAR_STUDENTS,
  payload: {
    request: {
      data: {
        class_id: class_id ?? "",
        entrance_year: entrance_year ?? "",
      },
      method: "get",
      url: `${API_URL}/students/next_year`,
    },
  },
});

export const clearStudents = () => ({
  types: CLEAR_STUDENTS as typeof CLEAR_STUDENTS,
  payload: {},
});

export const fetchStudent = (id: number) => ({
  types: FETCH_STUDENT as typeof FETCH_STUDENT,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/students/${id}`,
    },
  },
});

export const fetchNotification = (id: number) => ({
  types: FETCH_NOTIFICATION as typeof FETCH_NOTIFICATION,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/notifications/${id}`,
    },
  },
});

export const fetchNotifications = () => ({
  types: FETCH_NOTIFICATIONS as typeof FETCH_NOTIFICATIONS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/notifications`,
    },
  },
});

export const fetchSchoolDocuments = (
  category: TManagerSchoolDocumentCategory,
) => ({
  types: FETCH_SCHOOL_DOCUMENTS as typeof FETCH_SCHOOL_DOCUMENTS,
  payload: {
    request: {
      data: { category },
      method: "get",
      url: `${API_URL}/school_documents`,
    },
  },
});
export const createSchoolOrderChangeRequest = (
  changes: {
    entrance_year: number;
    dlp_registrable_num: number;
    g4s_registrable_num: number;
  }[],
  reason: string,
) => ({
  types:
    CREATE_SCHOOL_ORDER_CHANGE_REQUEST as typeof CREATE_SCHOOL_ORDER_CHANGE_REQUEST,
  payload: {
    request: {
      data: { changes, reason },
      method: "POST",
      url: `${API_URL}/school_order_change_requests`,
    },
  },
});
export const createNotification = (notification: {
  content: string;
  for_teacher: boolean;
  class_ids: number[];
}) => ({
  types: CREATE_NOTIFICATION as typeof CREATE_NOTIFICATION,
  payload: {
    request: {
      data: notification,
      method: "POST",
      url: `${API_URL}/notifications`,
    },
  },
});
export const updateNotification = (notification: {
  id: number;
  content: string;
  for_teacher: boolean;
  class_ids: number[];
}) => ({
  types: UPDATE_NOTIFICATION as typeof UPDATE_NOTIFICATION,
  payload: {
    request: {
      data: notification,
      method: "PUT",
      url: `${API_URL}/notifications/${notification.id}`,
    },
  },
});

export const destroyNotification = (id: number) => ({
  types: DESTROY_NOTIFICATION as typeof DESTROY_NOTIFICATION,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/notifications/${id}`,
    },
  },
});

export const resetStudentPassword = (id: number) => ({
  types: RESET_STUDENT_PASSWORD as typeof RESET_STUDENT_PASSWORD,
  payload: {
    request: {
      data: {},
      method: "post",
      url: `${API_URL}/students/${id}/reset_password`,
    },
  },
});

export const masqueradeTeacher = (teacher_id: number, app: string) => {
  return {
    types: MASQUERADE_TEACHER as typeof MASQUERADE_TEACHER,
    payload: {
      request: {
        data: { app },
        method: "post",
        url: `${API_URL}/teachers/${teacher_id}/masquerade`,
      },
    },
  };
};

export const masqueradeStudent = (student_id: number, app: string) => {
  return {
    types: MASQUERADE_STUDENT as typeof MASQUERADE_STUDENT,
    payload: {
      request: {
        data: { app },
        method: "post",
        url: `${API_URL}/students/${student_id}/masquerade`,
      },
    },
  };
};

export const fetchTemporaryToken = () => ({
  types: FETCH_TEMPORARY_TOKEN as typeof FETCH_TEMPORARY_TOKEN,
  payload: {
    request: {
      method: "post",
      url: `${API_URL}/sessions/temporary`,
    },
  },
});

export const fetchTotalStatus = (target: string) => ({
  types: FETCH_TOTAL_STATUS as typeof FETCH_TOTAL_STATUS,
  payload: {
    request: {
      method: "get",
      data: { target },
      url: `${API_URL}/realizations/total_status`,
    },
  },
});

export const fetchSummaryPerClass = (target: string, span: string) => ({
  types: FETCH_SUMMARY_PER_CLASS as typeof FETCH_SUMMARY_PER_CLASS,
  payload: {
    request: {
      method: "get",
      data: { target, span },
      url: `${API_URL}/realizations/summary_per_class`,
    },
  },
});

export const fetchSummaryPerTeacher = (target: string, span: string) => ({
  types: FETCH_SUMMARY_PER_TEACHER as typeof FETCH_SUMMARY_PER_TEACHER,
  payload: {
    request: {
      method: "get",
      data: { target, span },
      url: `${API_URL}/reactions/summary_per_teacher`,
    },
  },
});

export const fetchPlans = () => ({
  types: FETCH_PLANS as typeof FETCH_PLANS,
  payload: {
    request: {
      method: "get",
      url: `${API_URL}/plans`,
    },
  },
});

export const exchangeYearNow = () => ({
  types: EXCHANGE_YEAR_NOW_REQUEST as typeof EXCHANGE_YEAR_NOW_REQUEST,
  payload: {
    request: {
      method: "put",
      url: `${API_URL}/schools`,
    },
  },
});

export const checkSchoolStatus = () => ({
  types: CHECK_SCHOOL_STATUS as typeof CHECK_SCHOOL_STATUS,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/schools/exchange_year_status`,
    },
  },
});

export const updateSchoolStockCToC = (schoolStockCToC: boolean) => ({
  types: UPDATE_SCHOOL_STOCK_C_TO_C as typeof UPDATE_SCHOOL_STOCK_C_TO_C,
  payload: {
    request: {
      data: { stock_c_to_c_enabled: schoolStockCToC },
      method: "put",
      url: `${API_URL}/schools/update_stock_c_to_c`,
    },
  },
});

export const clearSuccessMessage = () => ({
  types: CLEAR_SUCCESS_MESSAGE as typeof CLEAR_SUCCESS_MESSAGE,
  payload: {},
});

export const clearErrorMessage = () => ({
  types: CLEAR_ERROR_MESSAGE as typeof CLEAR_ERROR_MESSAGE,
  payload: {},
});

export const clearTemporaryToken = () => ({
  types: CLEAR_TEMPORARY_TOKEN as typeof CLEAR_TEMPORARY_TOKEN,
  payload: {},
});

export const clearOTT = () => ({
  types: CLEAR_OTT as typeof CLEAR_OTT,
  payload: {},
});

export const fetchStudentRealPhotoUploadedFiles = () => ({
  types:
    FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES as typeof FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/student_real_photos/uploaded_files`,
    },
  },
});

export const uploadStudentRealPhotos = (
  request: UploadStudentRealPhotosRequest,
) => {
  const data: { [k: string]: File } = {};
  request.files.forEach((file, i) => {
    data[`files[${i}]`] = file;
  });
  return {
    types: UPLOAD_STUDENT_REAL_PHOTOS as typeof UPLOAD_STUDENT_REAL_PHOTOS,
    payload: {
      request: {
        method: "post",
        url: `${API_URL}/student_real_photos/upload`,
        data,
      },
    },
  };
};

export const bulkUpsertStudentRealPhotos = (
  data: BulkUpsertStudentRealPhotosRequest,
) => ({
  types:
    BULK_UPSERT_STUDENT_REAL_PHOTOS as typeof BULK_UPSERT_STUDENT_REAL_PHOTOS,
  payload: {
    request: {
      method: "POST",
      url: `${API_URL}/student_real_photos/bulk_upsert`,
      data,
    },
  },
});

export const deleteStudentRealPhotoUploadedFile = (id: number) => ({
  types:
    DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE as typeof DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE,
  payload: {
    request: {
      method: "DELETE",
      url: `${API_URL}/student_real_photos/${id}`,
    },
  },
});

export const deleteRealization = (id: number) => ({
  types: DELETE_REALIZATION as typeof DELETE_REALIZATION,
  payload: {
    request: {
      method: "DELETE",
      url: `${API_URL}/realizations/${id}`,
    },
  },
});

export const fetchTeacherSubjectsBySchool = () => ({
  types:
    FETCH_TEACHER_SUBJECTS_BY_SCHOOL as typeof FETCH_TEACHER_SUBJECTS_BY_SCHOOL,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/teacher_subjects/by_school`,
    },
  },
});

export const fetchTeacherSubjectsByTeacher = (teacher_id: number) => ({
  types:
    FETCH_TEACHER_SUBJECTS_BY_TEACHER as typeof FETCH_TEACHER_SUBJECTS_BY_TEACHER,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/teachers/${teacher_id}/teacher_subjects/by_teacher`,
    },
  },
});

export const submitTeacherSubjects = (
  teacher_id: number,
  subjects: {
    subject_id: number;
    klass_ids: number[];
  }[],
) => ({
  types: SUBMIT_TEACHER_SUBJECTS as typeof SUBMIT_TEACHER_SUBJECTS,
  payload: {
    request: {
      method: "POST",
      url: `${API_URL}/teachers/${teacher_id}/teacher_subjects`,
      data: {
        teacher_subject: { subjects },
      },
    },
  },
});

export const deleteTeacherSubject = (teacher_id: number, id: number) => ({
  types: DELETE_TEACHER_SUBJECT as typeof DELETE_TEACHER_SUBJECT,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/teachers/${teacher_id}/teacher_subjects/${id}`,
    },
  },
});

export const fetchSubjects = () => ({
  types: FETCH_SUBJECTS as typeof FETCH_SUBJECTS,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/subjects`,
    },
  },
});

export const fetchSubjectCategories = () => ({
  types: FETCH_SUBJECT_CATEGORIES as typeof FETCH_SUBJECT_CATEGORIES,
  payload: {
    request: {
      method: "GET",
      url: `${API_URL}/subject_categories`,
    },
  },
});

export const submitSubject = (name: string) => ({
  types: SUBMIT_SUBJECT as typeof SUBMIT_SUBJECT,
  payload: {
    request: {
      method: "POST",
      url: `${API_URL}/subjects`,
      data: {
        subject: { name },
      },
    },
  },
});

export const updateSubject = (name: string, id: number) => ({
  types: UPDATE_SUBJECT as typeof UPDATE_SUBJECT,
  payload: {
    request: {
      method: "PUT",
      url: `${API_URL}/subjects/${id}`,
      data: {
        subject: { name },
      },
    },
  },
});

export const deleteSubject = (id: number) => ({
  types: DELETE_SUBJECT as typeof DELETE_SUBJECT,
  payload: {
    request: {
      method: "delete",
      url: `${API_URL}/subjects/${id}`,
    },
  },
});

type loginSuccess = {
  types: typeof LOGIN_SUCCESS;
  payload: {
    data: ILoginResponse | ILoginMFAResponse;
  };
};

type loginFailure = {
  types: typeof LOGIN_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type verifyMFASuccess = {
  types: typeof VERIFY_MFA_SUCCESS;
  payload: {
    data: ILoginResponse;
  };
};

type verifyMFAFailure = {
  types: typeof VERIFY_MFA_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type logoutSuccess = {
  types: typeof LOGOUT_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type fetchInitialDataSuccess = {
  types: typeof FETCH_INITIAL_DATA_SUCCESS;
  payload: {
    data: {
      user_manager: IUserManager;
    };
  };
};

type fetchTeachersSuccess = {
  types: typeof FETCH_TEACHERS_SUCCESS;
  payload: {
    data: {
      teachers: ITeacher[];
    };
  };
};

type fetchTeacherSuccess = {
  types: typeof FETCH_TEACHER_SUCCESS;
  payload: {
    data: {
      teacher: ITeacher;
    };
  };
};

type fetchClassSuccess = {
  types: typeof FETCH_CLASS_SUCCESS;
  payload: {
    data: {
      class: IClass;
    };
  };
};

type fetchTemporaryTokenSuccess = {
  types: typeof FETCH_TEMPORARY_TOKEN_SUCCESS;
  payload: {
    data: {
      token: string;
    };
  };
};

type fetchNotificationsSuccess = {
  types: typeof FETCH_NOTIFICATIONS_SUCCESS;
  payload: {
    data: {
      notifications: INotification[];
    };
  };
};

type createTeacherSuccess = {
  types: typeof CREATE_TEACHER_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type createTeacherFailure = {
  types: typeof CREATE_TEACHER_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type updateTeacherSuccess = {
  types: typeof UPDATE_TEACHER_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type updateTeacherFailure = {
  types: typeof UPDATE_TEACHER_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type deleteTeacherSuccess = {
  types: typeof DELETE_TEACHER_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type deleteTeacherFailure = {
  types: typeof DELETE_TEACHER_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type resetStudentPasswordSuccess = {
  types: typeof RESET_STUDENT_PASSWORD_SUCCESS;
  payload: {
    data: { student: IStudent };
  };
};

type fetchNotificationSuccess = {
  types: typeof FETCH_NOTIFICATION_SUCCESS;
  payload: {
    data: { notification: INotification };
  };
};

type fetchReportsSuccess = {
  types: typeof FETCH_REPORTS_SUCCESS;
  payload: {
    data: { reports: IReportEntry[] };
  };
};

type createNotificationSuccess = {
  types: typeof CREATE_NOTIFICATION_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type createSchoolOrderChangeRequestSuccess = {
  types: typeof CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type createSchoolOrderChangeRequestFailure = {
  types: typeof CREATE_SCHOOL_ORDER_CHANGE_REQUEST_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type fetchSchoolDocumentsSuccess = {
  types: typeof FETCH_SCHOOL_DOCUMENTS_SUCCESS;
  payload: {
    data: { school_documents: ISchoolDocumentListItem[] };
  };
};

type fetchSchoolDocumentsFailure = {
  types: typeof FETCH_SCHOOL_DOCUMENTS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type updateNotificationSuccess = {
  types: typeof UPDATE_NOTIFICATION_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type destroyNotificationSuccess = {
  types: typeof DESTROY_NOTIFICATION_SUCCESS;
  payload: {
    params: { url: string };
    data: Record<string, unknown>;
  };
};

type bulkUpsertStudentsSuccess = {
  types: typeof BULK_UPSERT_STUDENTS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};
type bulkUpsertStudentsFailure = {
  types: typeof BULK_UPSERT_STUDENTS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type bulkUpsertTeacherSubjectsSuccess = {
  types: typeof BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};
type bulkUpsertTeacherSubjectsFailure = {
  types: typeof BULK_UPSERT_TEACHER_SUBJECTS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type bulkRegisterTeachersSuccess = {
  types: typeof BULK_REGISTER_TEACHERS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type bulkRegisterTeachersFailure = {
  types: typeof BULK_REGISTER_TEACHERS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type bulkUpsertClassesSuccess = {
  types: typeof BULK_UPSERT_CLASSES_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type disableStudentPlansFailure = {
  types: typeof DISABLE_STUDENT_PLANS_FAILURE;
  payload: {
    error: {
      message: string;
      field?: string;
      status?: number;
    };
  };
};

type disableStudentPlansSuccess = {
  types: typeof DISABLE_STUDENT_PLANS_SUCCESS;
  payload: {
    data: { id: number };
  };
};

type fetchStudentPlanSuccess = {
  types: typeof FETCH_STUDENT_PLANS_SUCCESS;
  payload: {
    data: { student_plans: IStudentPlan[] };
  };
};

type fetchClassesSuccess = {
  types: typeof FETCH_CLASSES_SUCCESS;
  payload: {
    data: {
      classes: IClass[];
    };
  };
};

type fetchNextClassesSuccess = {
  types: typeof FETCH_NEXT_CLASSES_SUCCESS;
  payload: {
    data: {
      classes: IClass[];
    };
  };
};

type fetchSubClassesSuccess = {
  types: typeof FETCH_SUB_CLASSES_SUCCESS;
  payload: {
    data: {
      classes: ISubClass[];
    };
  };
};

type fetchPlansSuccess = {
  types: typeof FETCH_PLANS_SUCCESS;
  payload: {
    data: {
      plans: IStudentPlan[];
    };
  };
};

type updateSubClassStudentsSuccess = {
  types: typeof UPDATE_SUB_CLASS_STUDENTS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type createClassSuccess = {
  types: typeof CREATE_CLASS_SUCCESS;
  payload: {
    params: { teacher_ids: number[] };
    data: { id: number };
  };
};

type createClassFailure = {
  types: typeof CREATE_CLASS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type updateClassSuccess = {
  types: typeof UPDATE_CLASS_SUCCESS;
  payload: {
    params: { teacher_ids: number[] };
    data: { id: number };
  };
};

type updateClassFailure = {
  types: typeof UPDATE_CLASS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type deleteClassSuccess = {
  types: typeof DELETE_CLASS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type deleteClassFailure = {
  types: typeof DELETE_CLASS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type deleteSubClassSuccess = {
  types: typeof DELETE_SUB_CLASS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type fetchStudentSuccess = {
  types: typeof FETCH_STUDENT_SUCCESS;
  payload: {
    data: {
      student: IStudent;
    };
  };
};

type fetchStudentsSuccess = {
  types: typeof FETCH_STUDENTS_SUCCESS;
  payload: {
    data: {
      data: {
        students: IStudent[];
      };
    };
  };
};

type fetchNextYearStudentsSuccess = {
  types: typeof FETCH_NEXT_YEAR_STUDENTS_SUCCESS;
  payload: {
    data: {
      data: {
        students: IStudent[];
      };
    };
  };
};

type fetchTotalStatusSuccess = {
  types: typeof FETCH_TOTAL_STATUS_SUCCESS;
  payload: {
    data: {
      total_status: ITotalStatus;
    };
  };
};
type fetchSummaryPerClassSuccess = {
  types: typeof FETCH_SUMMARY_PER_CLASS_SUCCESS;
  payload: {
    data: {
      summaries: ISummaryPerClass[];
    };
  };
};
type fetchSummaryPerTeacherSuccess = {
  types: typeof FETCH_SUMMARY_PER_TEACHER_SUCCESS;
  payload: {
    data: {
      summaries: ISummaryPerTeacher[];
    };
  };
};
type createStudentSuccess = {
  types: typeof CREATE_STUDENT_SUCCESS;
  payload: {
    params: { teacher_ids: number[] };
    data: { id: number };
  };
};

type createStudentFailure = {
  types: typeof CREATE_STUDENT_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type updateStudentSuccess = {
  types: typeof UPDATE_STUDENT_SUCCESS;
  payload: {
    params: { teacher_ids: number[] };
    data: { id: number };
  };
};

type updateStudentFailure = {
  types: typeof UPDATE_STUDENT_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type deleteStudentSuccess = {
  types: typeof DELETE_STUDENT_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type deleteStudentFailure = {
  types: typeof DELETE_STUDENT_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type bulkDeleteStudentsSuccess = {
  types: typeof BULK_DELETE_STUDENTS_SUCCESS;
  payload: {
    data: { deleted_ids: number[] };
  };
};

type bulkDeleteStudentsFailure = {
  types: typeof BULK_DELETE_STUDENTS_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      failed_ids?: number[];
      status: number;
    };
  };
};

type masqueradeTeacherSuccess = {
  types: typeof MASQUERADE_TEACHER_SUCCESS;
  payload: {
    params: { app: string };
    data: { session_id: string };
  };
};

type masqueradeStudentSuccess = {
  types: typeof MASQUERADE_STUDENT_SUCCESS;
  payload: {
    params: { app: string };
    data: { session_id: string };
  };
};

type fetchInitialDataFailure = {
  types: typeof FETCH_INITIAL_DATA_FAILURE;
  payload: {
    error: { message: string; field: string };
  };
};

type exchangeYearNowSuccess = {
  types: typeof EXCHANGE_YEAR_NOW_REQUEST_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};

type exchangeYearNowFailure = {
  types: typeof EXCHANGE_YEAR_NOW_REQUEST_FAILURE;
  payload: {
    error: {
      message: string;
      status: number;
    };
  };
};

type checkSchoolStatusSuccess = {
  types: typeof CHECK_SCHOOL_STATUS_SUCCESS;
  payload: {
    data: {
      data: {
        school: {
          change_current_year_status: "open" | "inprogress" | "done";
        };
      };
    };
  };
};

type updateSchoolStockCToCSuccess = {
  types: typeof UPDATE_SCHOOL_STOCK_C_TO_C_SUCCESS;
  payload: {
    data: { stock_c_to_c_enabled: boolean };
  };
};

type updateSchoolStockCToCFailure = {
  types: typeof UPDATE_SCHOOL_STOCK_C_TO_C_FAILURE;
  payload: {
    error: {
      message: string;
      field: string;
      status: number;
    };
  };
};

type fetchStudentRealPhotosUploadedFilesSuccess = {
  types: typeof FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES_SUCCESS;
  payload: {
    data: UploadStudentRealPhotosResponse;
  };
};

type uploadStudentRealPhotosSuccess = {
  types: typeof UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS;
  payload: {
    data: UploadStudentRealPhotosResponse;
  };
};
type uploadStudentRealPhotosFailure = {
  types: typeof UPLOAD_STUDENT_REAL_PHOTOS_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};
type deleteStudentRealPhotoUploadedFileSuccess = {
  types: typeof DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_SUCCESS;
  payload: {
    data: {
      id: number;
    };
  };
};
type deleteStudentRealPhotoUploadedFileFailure = {
  types: typeof DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};
type clearStudentRealPhotos = {
  types: typeof CLEAR_STUDENT_REAL_PHOTOS;
};
type bulkUpsertStudentRealPhotosSuccess = {
  types: typeof BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS;
  payload: {
    data: Record<string, unknown>;
  };
};
type bulkUpsertStudentRealPhotosFailure = {
  types: typeof BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type deleteRealizationSuccess = {
  types: typeof DELETE_REALIZATION_SUCCESS;
  payload: {
    params: { url: string };
    data: Record<string, unknown>;
  };
};

type deleteRealizationFailure = {
  types: typeof DELETE_REALIZATION_FAILURE;
  payload: {
    error: {
      message: string;
      field?: string;
      status?: number;
    };
  };
};

type fetchTeacherSubjectsBySchoolSuccess = {
  types: typeof FETCH_TEACHER_SUBJECTS_BY_SCHOOL_SUCCESS;
  payload: {
    data: {
      teachers: TeacherSubject[];
    };
  };
};

type fetchTeacherSubjectsByTeacherSuccess = {
  types: typeof FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS;
  payload: {
    data: {
      teacher: TeacherSubject;
    };
  };
};

type submitTeacherSubjectsSuccess = {
  types: typeof SUBMIT_TEACHER_SUBJECTS_SUCCESS;
  payload: {
    data: {
      teacher_subjects: {
        id: number;
        teacher_id: number;
        subject_id: number;
        subject_name: string;
      };
    };
  };
};

type submitTeacherSubjectsFailure = {
  types: typeof SUBMIT_TEACHER_SUBJECTS_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type deleteTeacherSubjectSuccess = {
  types: typeof DELETE_TEACHER_SUBJECT_SUCCESS;
  payload: {
    data: {
      id: number;
    };
  };
};

type deleteTeacherSubjectFailure = {
  types: typeof DELETE_TEACHER_SUBJECT_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type fetchSubjectsSuccess = {
  types: typeof FETCH_SUBJECTS_SUCCESS;
  payload: {
    data: {
      subjects: Subject[];
    };
  };
};

type submitSubjectSuccess = {
  types: typeof SUBMIT_SUBJECT_SUCCESS;
  payload: {
    data: {
      subject: Subject;
    };
  };
};

type submitSubjectFailure = {
  types: typeof SUBMIT_SUBJECT_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type updateSubjectSuccess = {
  types: typeof UPDATE_SUBJECT_SUCCESS;
  payload: {
    data: {
      subject: Subject;
    };
  };
};

type updateSubjectFailure = {
  types: typeof UPDATE_SUBJECT_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type deleteSubjectSuccess = {
  types: typeof DELETE_SUBJECT_SUCCESS;
  payload: {
    data: {
      subject_id: number;
    };
  };
};

type deleteSubjectFailure = {
  types: typeof DELETE_SUBJECT_FAILURE;
  payload: {
    error: {
      message: string;
    };
  };
};

type fetchSubjectCategoriesSuccess = {
  types: typeof FETCH_SUBJECT_CATEGORIES_SUCCESS;
  payload: {
    data: {
      subject_categories: SubjectCategory[];
    };
  };
};

type action503 = {
  types: typeof ACTION_503;
};

export type Actions =
  | ReturnType<typeof login>
  | ReturnType<typeof verifyMFA>
  | ReturnType<typeof logout>
  | ReturnType<typeof fetchInitialData>
  | ReturnType<typeof fetchTeachers>
  | ReturnType<typeof fetchTeacher>
  | ReturnType<typeof createTeacher>
  | ReturnType<typeof updateTeacher>
  | ReturnType<typeof deleteTeacher>
  | ReturnType<typeof fetchClasses>
  | ReturnType<typeof fetchNextClasses>
  | ReturnType<typeof fetchSubClasses>
  | ReturnType<typeof fetchClass>
  | ReturnType<typeof fetchPlans>
  | ReturnType<typeof createClass>
  | ReturnType<typeof updateClass>
  | ReturnType<typeof deleteClass>
  | ReturnType<typeof updateSubClassStudents>
  | ReturnType<typeof deleteSubClass>
  | ReturnType<typeof fetchStudents>
  | ReturnType<typeof fetchStudentPlans>
  | ReturnType<typeof fetchNextYearStudents>
  | ReturnType<typeof clearStudents>
  | ReturnType<typeof fetchStudent>
  | ReturnType<typeof fetchTemporaryToken>
  | ReturnType<typeof fetchTotalStatus>
  | ReturnType<typeof fetchSummaryPerClass>
  | ReturnType<typeof fetchSummaryPerTeacher>
  | ReturnType<typeof fetchNotifications>
  | ReturnType<typeof fetchNotification>
  | ReturnType<typeof fetchReports>
  | ReturnType<typeof createNotification>
  | ReturnType<typeof createSchoolOrderChangeRequest>
  | ReturnType<typeof fetchSchoolDocuments>
  | ReturnType<typeof updateNotification>
  | ReturnType<typeof destroyNotification>
  | ReturnType<typeof clearTemporaryToken>
  | ReturnType<typeof createStudent>
  | ReturnType<typeof updateStudent>
  | ReturnType<typeof deleteStudent>
  | ReturnType<typeof bulkDeleteStudents>
  | ReturnType<typeof resetStudentPassword>
  | ReturnType<typeof bulkUpsertStudents>
  | ReturnType<typeof bulkUpsertTeacherSubjects>
  | ReturnType<typeof bulkUpsertClasses>
  | ReturnType<typeof disableStudentPlans>
  | ReturnType<typeof bulkRegisterTeachers>
  | ReturnType<typeof masqueradeTeacher>
  | ReturnType<typeof masqueradeStudent>
  | ReturnType<typeof exchangeYearNow>
  | ReturnType<typeof checkSchoolStatus>
  | ReturnType<typeof updateSchoolStockCToC>
  | ReturnType<typeof fetchStudentRealPhotoUploadedFiles>
  | ReturnType<typeof uploadStudentRealPhotos>
  | ReturnType<typeof bulkUpsertStudentRealPhotos>
  | ReturnType<typeof deleteStudentRealPhotoUploadedFile>
  | ReturnType<typeof deleteRealization>
  | ReturnType<typeof fetchTeacherSubjectsBySchool>
  | ReturnType<typeof fetchTeacherSubjectsByTeacher>
  | ReturnType<typeof submitTeacherSubjects>
  | ReturnType<typeof deleteTeacherSubject>
  | ReturnType<typeof fetchSubjects>
  | ReturnType<typeof fetchSubjectCategories>
  | ReturnType<typeof submitSubject>
  | ReturnType<typeof updateSubject>
  | ReturnType<typeof deleteSubject>
  | ReturnType<typeof clearSuccessMessage>
  | ReturnType<typeof clearErrorMessage>
  | ReturnType<typeof clearOTT>
  | loginSuccess
  | loginFailure
  | verifyMFASuccess
  | verifyMFAFailure
  | fetchInitialDataSuccess
  | fetchInitialDataFailure
  | fetchTeachersSuccess
  | fetchTeacherSuccess
  | fetchTemporaryTokenSuccess
  | fetchNotificationsSuccess
  | createTeacherSuccess
  | createTeacherFailure
  | updateTeacherSuccess
  | updateTeacherFailure
  | deleteTeacherSuccess
  | deleteTeacherFailure
  | fetchClassesSuccess
  | fetchNextClassesSuccess
  | fetchSubClassesSuccess
  | fetchPlansSuccess
  | updateSubClassStudentsSuccess
  | fetchClassSuccess
  | fetchTotalStatusSuccess
  | fetchSummaryPerClassSuccess
  | fetchSummaryPerTeacherSuccess
  | fetchNotificationSuccess
  | fetchReportsSuccess
  | createNotificationSuccess
  | createSchoolOrderChangeRequestSuccess
  | createSchoolOrderChangeRequestFailure
  | fetchSchoolDocumentsSuccess
  | fetchSchoolDocumentsFailure
  | updateNotificationSuccess
  | destroyNotificationSuccess
  | createClassSuccess
  | createClassFailure
  | updateClassSuccess
  | updateClassFailure
  | deleteClassSuccess
  | deleteClassFailure
  | deleteSubClassSuccess
  | bulkUpsertStudentsSuccess
  | bulkUpsertStudentsFailure
  | bulkUpsertTeacherSubjectsSuccess
  | bulkUpsertTeacherSubjectsFailure
  | bulkUpsertClassesSuccess
  | fetchStudentPlanSuccess
  | disableStudentPlansSuccess
  | disableStudentPlansFailure
  | bulkRegisterTeachersSuccess
  | bulkRegisterTeachersFailure
  | fetchStudentsSuccess
  | fetchNextYearStudentsSuccess
  | fetchStudentSuccess
  | createStudentSuccess
  | createStudentFailure
  | resetStudentPasswordSuccess
  | updateStudentSuccess
  | updateStudentFailure
  | deleteStudentSuccess
  | deleteStudentFailure
  | bulkDeleteStudentsSuccess
  | bulkDeleteStudentsFailure
  | masqueradeStudentSuccess
  | masqueradeTeacherSuccess
  | exchangeYearNowSuccess
  | exchangeYearNowFailure
  | checkSchoolStatusSuccess
  | updateSchoolStockCToCSuccess
  | updateSchoolStockCToCFailure
  | fetchStudentRealPhotosUploadedFilesSuccess
  | uploadStudentRealPhotosSuccess
  | uploadStudentRealPhotosFailure
  | deleteStudentRealPhotoUploadedFileSuccess
  | deleteStudentRealPhotoUploadedFileFailure
  | clearStudentRealPhotos
  | bulkUpsertStudentRealPhotosSuccess
  | bulkUpsertStudentRealPhotosFailure
  | deleteRealizationSuccess
  | deleteRealizationFailure
  | fetchTeacherSubjectsBySchoolSuccess
  | fetchTeacherSubjectsByTeacherSuccess
  | submitTeacherSubjectsSuccess
  | submitTeacherSubjectsFailure
  | deleteTeacherSubjectSuccess
  | deleteTeacherSubjectFailure
  | fetchSubjectsSuccess
  | fetchSubjectCategoriesSuccess
  | submitSubjectSuccess
  | submitSubjectFailure
  | updateSubjectSuccess
  | updateSubjectFailure
  | deleteSubjectSuccess
  | deleteSubjectFailure
  | logoutSuccess
  | action503;

export type AppState = {
  session_id: string;
  isMasqueradeByAdmin: boolean;
  temporary_token: string;
  school_documents_list: ISchoolDocumentListItem[];
  temporary_session_id: string;
  error: string;
  error_field: string;
  success_message: string;
  success_result: { [key: string]: any };
  isServiceUnavailable: boolean;
  isLoaderVisible: boolean;
  classes: IClass[];
  next_classes: IClass[];
  sub_classes: ISubClass[];
  teachers: ITeacher[];
  students: IStudent[];
  next_year_students: IStudent[];
  manager: IUserManager;
  total_status: ITotalStatus;
  class_summaries: ISummaryPerClass[];
  teacher_summaries: ISummaryPerTeacher[];
  notifications: INotification[];
  notification?: INotification;
  ott: string;
  report_entries: IReportEntry[];
  lastAction: string;
  expires: Date;
  plans: IStudentPlan[];
  student_plans: IStudentPlan[];
  bulk_delete_failed_ids: number[];
  uploaded_student_real_photos: IFile[];
  teacher_subjects_by_school: TeacherSubject[];
  teacher_subjects_by_teacher: TeacherSubject;
  subjects: Subject[];
  subject_categories: SubjectCategory[];
};

export const InitialAppState: AppState = {
  session_id: "",
  isMasqueradeByAdmin: false,
  error: "",
  error_field: "",
  success_message: "",
  success_result: {},
  temporary_token: "",
  school_documents_list: [],
  temporary_session_id: "",
  isServiceUnavailable: false,
  isLoaderVisible: false,
  classes: [],
  plans: [],
  bulk_delete_failed_ids: [],
  next_classes: [],
  sub_classes: [],
  students: [],
  next_year_students: [],
  teachers: [],
  class_summaries: [],
  teacher_summaries: [],
  notifications: [],
  report_entries: [],
  manager: {
    id: 0,
    account_id: null,
    first_name: "",
    last_name: "",
    first_name_kana: "",
    last_name_kana: "",
    email: "",
    roles: 0,
    school: {
      id: 0,
      name: "",
      name_kana: "",
      code: "",
      classification: "",
      zip_code: "",
      pref_code: "",
      tel: "",
      address1: "",
      address2: "",
      total_dlp_registrable_num: 0,
      dlp_test_account_num: 0,
      total_g4s_registrable_num: 0,
      g4s_test_account_num: 0,
      g4s_enabled: false,
      serviced: false,
      current_year: 0,
      changed_current_year_plan_date: null,
      change_current_year_status: "done",
      has_g4s_order: false,
      has_g4s_basic_order: false,
      has_dlp_order: false,
    },
  },
  ott: "",
  total_status: {
    realization_count: 0,
    last_posted_at: undefined,
    teachers_comment_count: 0,
  },
  lastAction: "",
  expires: addHours(new Date(), 6),
  student_plans: [],
  uploaded_student_real_photos: [],
  teacher_subjects_by_school: [],
  teacher_subjects_by_teacher: {
    teacher_id: 0,
    teacher_name: "",
    subjects: [],
  },
  subjects: [],
  subject_categories: [],
};

function isLoginMFA(
  data: ILoginResponse | ILoginMFAResponse,
): data is ILoginMFAResponse {
  return (data as ILoginMFAResponse).ott !== undefined;
}

export const reducer = (state: AppState, action: Actions): AppState => {
  const newState = { ...state, lastAction: action.types };
  switch (action.types) {
    case LOGIN_SUCCESS: {
      if (isLoginMFA(action.payload.data)) {
        const { ott } = action.payload.data;
        return {
          ...newState,
          error: "",
          error_field: "",
          ott,
        };
      }
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        session_id: data.session_id,
        manager: data.user_manager,
      };
    }
    case VERIFY_MFA_SUCCESS: {
      const { session_id, user_manager: manager } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        session_id,
        manager,
      };
    }
    case VERIFY_MFA_FAILURE: {
      const { message, field } = action.payload.error;
      return {
        ...newState,
        error: message,
        error_field: field,
      };
    }
    case FETCH_CLASSES: {
      return {
        ...newState,
        classes: [],
      };
    }
    case FETCH_NEXT_CLASSES: {
      return {
        ...newState,
        next_classes: [],
      };
    }
    case FETCH_SUB_CLASSES: {
      return {
        ...newState,
        sub_classes: [],
      };
    }
    case FETCH_PLANS: {
      return {
        ...newState,
        plans: [],
      };
    }
    case LOGIN:
    case CREATE_CLASS:
    case UPDATE_CLASS:
    case DELETE_CLASS:
    case BULK_UPSERT_CLASSES:
    case CREATE_TEACHER:
    case UPDATE_TEACHER:
    case DELETE_TEACHER:
    case MASQUERADE_TEACHER:
    case CREATE_STUDENT:
    case UPDATE_STUDENT:
    case DELETE_STUDENT:
    case BULK_DELETE_STUDENTS:
    case BULK_UPSERT_STUDENTS:
    case BULK_UPSERT_TEACHER_SUBJECTS:
    case MASQUERADE_STUDENT:
    case RESET_STUDENT_PASSWORD:
    case FETCH_TEMPORARY_TOKEN:
    case CREATE_NOTIFICATION:
    case CREATE_SCHOOL_ORDER_CHANGE_REQUEST:
    case UPDATE_NOTIFICATION:
    case DESTROY_NOTIFICATION:
    case UPDATE_SUB_CLASS_STUDENTS:
    case EXCHANGE_YEAR_NOW_REQUEST:
    case DELETE_REALIZATION: {
      return {
        ...newState,
      };
    }
    case FETCH_INITIAL_DATA_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        manager: data.user_manager,
        session_id: data.user_manager.id ? state.session_id : "",
      };
    }
    case FETCH_TEMPORARY_TOKEN_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        temporary_token: data.token,
      };
    }
    case CLEAR_TEMPORARY_TOKEN: {
      return {
        ...newState,
        temporary_token: "",
      };
    }
    case MASQUERADE_STUDENT_SUCCESS: {
      return {
        ...newState,
        success_message: MASQUERADE_STUDENT_SUCCESS_MESSAGE,
        success_result: { app: action.payload.params.app },
        temporary_session_id: action.payload.data.session_id,
      };
    }
    case MASQUERADE_TEACHER_SUCCESS: {
      return {
        ...newState,
        success_message: MASQUERADE_TEACHER_SUCCESS_MESSAGE,
        success_result: { app: action.payload.params.app },
        temporary_session_id: action.payload.data.session_id,
      };
    }
    case FETCH_TEACHERS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teachers: data.teachers,
      };
    }
    case FETCH_TEACHER_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teachers: [data.teacher],
      };
    }
    case FETCH_REPORTS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        report_entries: data.reports.map(r => ({
          ...r,
          created_at: new Date(r.created_at),
          last_reported_at: new Date(r.last_reported_at),
        })),
      };
    }
    case FETCH_TOTAL_STATUS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        total_status: {
          ...data.total_status,
          last_posted_at: data.total_status.last_posted_at
            ? new Date(data.total_status.last_posted_at)
            : undefined,
        },
      };
    }
    case FETCH_SUMMARY_PER_CLASS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        class_summaries: data.summaries,
      };
    }
    case FETCH_SUMMARY_PER_TEACHER_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teacher_summaries: data.summaries,
      };
    }
    case FETCH_CLASSES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        classes: data.classes,
        error: "",
        error_field: "",
        success_message: FETCH_CLASSES_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case FETCH_NEXT_CLASSES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        next_classes: data.classes,
        error: "",
        error_field: "",
        success_message: FETCH_NEXT_CLASSES_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case FETCH_SUB_CLASSES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        sub_classes: data.classes,
        error: "",
        error_field: "",
        success_message: FETCH_SUB_CLASSES_SUCCESS_MESSAGE,
        success_result: {},
      };
    }

    case UPDATE_SUB_CLASS_STUDENTS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_SUB_CLASS_STUDENT_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case FETCH_STUDENTS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: FETCH_STUDENTS_SUCCESS_MESSAGE,
        success_result: {},
        students: data.students,
      };
    }
    case FETCH_NEXT_YEAR_STUDENTS_SUCCESS: {
      const { data } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: FETCH_NEXT_YEAR_STUDENTS_SUCCESS_MESSAGE,
        success_result: {},
        next_year_students: data.students,
      };
    }
    case CLEAR_STUDENTS: {
      return {
        ...newState,
        success_message: FETCH_STUDENTS_SUCCESS_MESSAGE,
        students: [],
      };
    }
    case FETCH_NOTIFICATIONS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: FETCH_NOTIFICATIONS_SUCCESS_MESSAGE,
        success_result: {},
        notifications: data.notifications.map(d => ({
          ...d,
          created_at: new Date(d.created_at),
          updated_at: new Date(d.updated_at),
        })),
      };
    }
    case FETCH_NOTIFICATION_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        notification: {
          ...data.notification,
          created_at: new Date(data.notification.created_at),
          updated_at: new Date(data.notification.updated_at),
        },
      };
    }
    case CREATE_NOTIFICATION_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: CREATE_NOTIFICATION_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: CREATE_SCHOOL_ORDER_CHANGE_REQUEST_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    // 書類種別の切替時にヘッダーと中身が食い違わないよう、取得開始時に一覧をクリアする
    case FETCH_SCHOOL_DOCUMENTS: {
      return {
        ...newState,
        school_documents_list: [],
      };
    }
    case FETCH_SCHOOL_DOCUMENTS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        school_documents_list: data.school_documents,
      };
    }
    case UPDATE_NOTIFICATION_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_NOTIFICATION_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DESTROY_NOTIFICATION_SUCCESS: {
      const id = parseInt(
        action.payload.params.url.split("/").pop() as string,
        10,
      );
      return {
        ...newState,
        error: "",
        error_field: "",
        notifications: state.notifications.filter(n => n.id !== id),
        success_message: DESTROY_NOTIFICATION_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case RESET_STUDENT_PASSWORD_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: FETCH_STUDENTS_SUCCESS_MESSAGE,
        success_result: {},
        students: state.students.map(s =>
          s.id === data.student.id ? data.student : s,
        ),
      };
    }
    case FETCH_INITIAL_DATA_FAILURE: {
      return { ...InitialAppState, lastAction: action.types };
    }
    case LOGIN_FAILURE:
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: action.payload.error.field,
      };
    case CREATE_TEACHER_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: CREATE_TEACHER_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case BULK_UPSERT_STUDENTS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: BULK_UPSERT_STUDENTS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: BULK_UPSERT_TEACHER_SUBJECTS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case BULK_UPSERT_CLASSES_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: BULK_UPSERT_CLASSES_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case BULK_REGISTER_TEACHERS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: BULK_REGISTER_TEACHERS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DISABLE_STUDENT_PLANS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: DISABLE_STUDENT_PLANS_SUCCESS_MESSAGE,
        success_result: {},
        students: state.students.map(s =>
          s.id === data.id ? { ...s, ...data } : s,
        ),
        next_year_students: state.next_year_students.map(s =>
          s.id === data.id ? { ...s, ...data } : s,
        ),
      };
    }
    case FETCH_STUDENT_PLANS_SUCCESS: {
      const { student_plans } = action.payload.data;
      return {
        ...newState,
        student_plans,
        error: "",
        error_field: "",
        success_message: FETCH_STUDENT_PLANS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case UPDATE_TEACHER_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_TEACHER_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DELETE_TEACHER_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: DELETE_TEACHER_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case CREATE_STUDENT_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: CREATE_STUDENT_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case UPDATE_STUDENT_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: UPDATE_STUDENT_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DELETE_STUDENT_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: DELETE_STUDENT_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case BULK_DELETE_STUDENTS_SUCCESS: {
      const { deleted_ids } = action.payload.data;
      return {
        ...newState,
        error: "",
        error_field: "",
        bulk_delete_failed_ids: [],
        success_message: BULK_DELETE_STUDENTS_SUCCESS_MESSAGE,
        success_result: {},
        students: state.students.filter(s => !deleted_ids.includes(s.id)),
      };
    }
    case BULK_DELETE_STUDENTS_FAILURE: {
      const failed_ids = action.payload.error.failed_ids;
      if (failed_ids?.length) {
        return {
          ...newState,
          bulk_delete_failed_ids: failed_ids,
        };
      }
      return {
        ...newState,
        error: BULK_DELETE_STUDENTS_FAILURE_MESSAGE,
      };
    }
    case CREATE_CLASS_SUCCESS: {
      const classID = action.payload.data.id;
      const teacher_ids = action.payload.params.teacher_ids;
      const teachers = state.teachers.map(t =>
        teacher_ids.indexOf(t.id) !== -1
          ? { ...t, class_ids: [...t.class_ids, classID] }
          : t,
      );
      return {
        ...newState,
        teachers,
        error: "",
        error_field: "",
        success_message: CREATE_CLASS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case UPDATE_CLASS_SUCCESS: {
      const classID = action.payload.data.id;
      const teacher_ids = action.payload.params.teacher_ids;
      const teachers = state.teachers.map(t =>
        teacher_ids.indexOf(t.id) !== -1
          ? {
              ...t,
              class_ids: Array.from(new Set([...t.class_ids, classID])),
            }
          : {
              ...t,
              class_ids: t.class_ids.filter(i => i !== classID),
            },
      );
      return {
        ...newState,
        teachers,
        error: "",
        error_field: "",
        success_message: UPDATE_CLASS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DELETE_CLASS_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: DELETE_CLASS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DELETE_SUB_CLASS_SUCCESS: {
      return {
        ...newState,
        sub_classes: state.sub_classes.filter(
          sub_class => sub_class.id !== action.payload.data.id,
        ),
        error: "",
        error_field: "",
        success_message: DELETE_SUB_CLASS_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case FETCH_CLASS_SUCCESS: {
      return {
        ...newState,
        classes: [action.payload.data.class],
      };
    }
    case FETCH_STUDENT_SUCCESS: {
      return {
        ...newState,
        students: [action.payload.data.student],
        next_year_students: [action.payload.data.student],
      };
    }
    case EXCHANGE_YEAR_NOW_REQUEST_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        success_message: EXCHANGE_YEAR_NOW_REQUEST_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case EXCHANGE_YEAR_NOW_REQUEST_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
      };
    }
    case CHECK_SCHOOL_STATUS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        manager: {
          ...state.manager,
          ...(state.manager?.school
            ? {
                school: {
                  ...state.manager.school,
                  change_current_year_status:
                    data.data.school.change_current_year_status,
                },
              }
            : undefined),
        },
        success_message:
          data.data.school.change_current_year_status === "done"
            ? EXCHANGE_YEAR_NOW_UPDATED_SUCCESS_MESSAGE
            : state.success_message,
      };
    }
    case FETCH_PLANS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        plans: data.plans,
      };
    }

    case UPDATE_SCHOOL_STOCK_C_TO_C_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        manager: {
          ...state.manager,
          ...(state.manager?.school
            ? {
                school: {
                  ...state.manager.school,
                  stock_c_to_c_enabled: data.stock_c_to_c_enabled,
                },
              }
            : undefined),
        },
      };
    }
    case FETCH_STUDENT_REAL_PHOTO_UPLOADED_FILES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        uploaded_student_real_photos: data.files,
      };
    }
    case UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        uploaded_student_real_photos: data.files,
        error: "",
        error_field: "",
        success_message: UPLOAD_STUDENT_REAL_PHOTOS_SUCCESS_MESSAGE,
      };
    }
    case UPLOAD_STUDENT_REAL_PHOTOS_FAILURE: {
      return {
        ...newState,
        error: UPLOAD_STUDENT_REAL_PHOTOS_FAILURE_MESSAGE,
      };
    }
    case DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        uploaded_student_real_photos:
          newState.uploaded_student_real_photos.filter(
            photo => photo.id !== data.id,
          ),
      };
    }
    case DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE: {
      return {
        ...newState,
        error: DELETE_STUDENT_REAL_PHOTO_UPLOADED_FILE_FAILURE_MESSAGE,
      };
    }
    case CLEAR_STUDENT_REAL_PHOTOS: {
      return {
        ...newState,
        uploaded_student_real_photos: [],
      };
    }
    case BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS: {
      return {
        ...newState,
        success_message: BULK_UPSERT_STUDENT_REAL_PHOTOS_SUCCESS_MESSAGE,
      };
    }
    case BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE: {
      return {
        ...newState,
        error: BULK_UPSERT_STUDENT_REAL_PHOTOS_FAILURE_MESSAGE,
      };
    }
    case DELETE_REALIZATION_SUCCESS: {
      return {
        ...newState,
        error: "",
        error_field: "",
        report_entries: state.report_entries.filter(
          entry => entry.realization_id !== action.payload.data.id,
        ),
        success_message: DELETE_REALIZATION_SUCCESS_MESSAGE,
        success_result: {},
      };
    }
    case DELETE_REALIZATION_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: action.payload.error.field || "",
      };
    }
    case FETCH_SCHOOL_DOCUMENTS_FAILURE:
    case CREATE_SCHOOL_ORDER_CHANGE_REQUEST_FAILURE:
    case BULK_UPSERT_TEACHER_SUBJECTS_FAILURE:
    case BULK_UPSERT_STUDENTS_FAILURE:
    case BULK_REGISTER_TEACHERS_FAILURE:
    case CREATE_TEACHER_FAILURE:
    case UPDATE_TEACHER_FAILURE:
    case DELETE_TEACHER_FAILURE:
    case CREATE_CLASS_FAILURE:
    case UPDATE_CLASS_FAILURE:
    case DELETE_CLASS_FAILURE:
    case CREATE_STUDENT_FAILURE:
    case UPDATE_STUDENT_FAILURE:
    case DELETE_STUDENT_FAILURE: {
      return {
        ...newState,
        error: action.payload.error.message,
        error_field: action.payload.error.field,
      };
    }
    case FETCH_TEACHER_SUBJECTS_BY_SCHOOL_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teacher_subjects_by_school: data.teachers,
      };
    }
    case FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        teacher_subjects_by_teacher: data.teacher,
        success_message: FETCH_TEACHER_SUBJECTS_BY_TEACHER_SUCCESS_MESSAGE,
      };
    }
    case SUBMIT_TEACHER_SUBJECTS_SUCCESS: {
      return {
        ...newState,
      };
    }
    case SUBMIT_TEACHER_SUBJECTS_FAILURE: {
      return {
        ...newState,
        error: SUBMIT_TEACHER_SUBJECTS_FAILURE_MESSAGE,
      };
    }
    case DELETE_TEACHER_SUBJECT_SUCCESS: {
      const { id } = action.payload.data;
      const newTeacherSubjects =
        state.teacher_subjects_by_teacher.subjects.filter(
          subject => subject.teacher_subject_id !== id,
        );
      return {
        ...newState,
        teacher_subjects_by_teacher: {
          ...state.teacher_subjects_by_teacher,
          subjects: newTeacherSubjects,
        },
        success_message: DELETE_TEACHER_SUBJECT_SUCCESS_MESSAGE,
      };
    }
    case DELETE_TEACHER_SUBJECT_FAILURE: {
      return {
        ...newState,
        error: DELETE_TEACHER_SUBJECT_FAILURE_MESSAGE,
      };
    }
    case FETCH_SUBJECTS_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        subjects: data.subjects,
      };
    }
    case FETCH_SUBJECT_CATEGORIES_SUCCESS: {
      const { data } = action.payload;
      return {
        ...newState,
        subject_categories: data.subject_categories,
      };
    }
    case SUBMIT_SUBJECT_SUCCESS: {
      const { subject } = action.payload.data;
      return {
        ...newState,
        subjects: [...state.subjects, subject],
        success_message: SUBMIT_SUBJECT_SUCCESS_MESSAGE,
      };
    }
    case SUBMIT_SUBJECT_FAILURE: {
      return {
        ...newState,
        error: SUBMIT_SUBJECT_FAILURE_MESSAGE,
      };
    }
    case UPDATE_SUBJECT_SUCCESS: {
      const { subject: updatedSubject } = action.payload.data;
      const newSubjects = state.subjects.map(subject =>
        subject.id === updatedSubject.id
          ? { ...subject, ...updatedSubject }
          : subject,
      );
      return {
        ...newState,
        subjects: newSubjects,
        success_message: UPDATE_SUBJECT_SUCCESS_MESSAGE,
      };
    }
    case UPDATE_SUBJECT_FAILURE: {
      return {
        ...newState,
        error: UPDATE_SUBJECT_FAILURE_MESSAGE,
      };
    }
    case DELETE_SUBJECT_SUCCESS: {
      const { subject_id: deletedId } = action.payload.data;
      const newSubjects = state.subjects.filter(
        subject => subject.id !== deletedId,
      );
      return {
        ...newState,
        subjects: newSubjects,
        success_message: DELETE_SUBJECT_SUCCESS_MESSAGE,
      };
    }
    case DELETE_SUBJECT_FAILURE: {
      return {
        ...newState,
        error: DELETE_SUBJECT_FAILURE_MESSAGE,
      };
    }
    case LOGOUT:
      return { ...InitialAppState };
    case LOGOUT_SUCCESS:
      return { ...InitialAppState, success_message: LOGOUT_SUCCESS_MESSAGE };
    case CLEAR_SUCCESS_MESSAGE:
      return { ...newState, success_message: "", success_result: {} };
    case CLEAR_ERROR_MESSAGE:
      return {
        ...newState,
        error: "",
        error_field: "",
        bulk_delete_failed_ids: [],
      };
    case CLEAR_OTT:
      return { ...newState, ott: "" };
    case ACTION_503:
      return {
        ...newState,
        isServiceUnavailable: true,
        success_message: ACTION_503_MESSAGE,
      };
    default:
      return newState;
  }
};

type ContextState = {
  state: AppState;
  dispatch(action: Actions): void;
};

export const Context = React.createContext<ContextState>({
  state: InitialAppState,
  dispatch(_) {
    console.warn("Context.Provider外からの呼び出し");
  },
});
